export default __webpack_public_path__ + "static/media/lu.3f119726.svg";